export const state = () => ({
	rows: [],
	meta: {},
	loading: false,
	error: false,
	request: 0
})
export const mutations = {
	start(state) {
		state.request++
		state.loading = true
		state.error = false
	},
	done(state, { request, data, error = false }) {
		if (state.request !== request) return
		state.loading = false
		state.error = error
		state.rows = data ? data.data : []
		state.meta = data ? data.meta : {}
	}
}
export const actions = {
	async search({ state, commit }, { organizationId, ...params }) {
		commit('start')
		const request = state.request
		try {
			const data = await this.$axios.$get(
				`organization/${organizationId}/email-templates`,
				{ params }
			)
			commit('done', { request, data })
		} catch (error) {
			commit('done', { request, error: true })
		}
	}
}
